import { Fade } from '@material-ui/core';
import { useVisibilityObserver } from '@superdispatch/ui';
import { Box, BoxProps as BoxPropsType } from '@superdispatch/ui-lab';
import { ReactNode, RefObject, useRef } from 'react';
import styled from 'styled-components';

const BottomFade = styled.div`
  height: 40px;
  width: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0) 100%
  );
`;

interface ScrollableViewportProps {
  BoxProps?: BoxPropsType;
  render: (ref: RefObject<HTMLDivElement>) => ReactNode;
}

export function ScrollableViewport({
  render,
  BoxProps,
}: ScrollableViewportProps) {
  const containerRef = useRef<HTMLElement>();
  const ref = useRef<HTMLDivElement>(null);

  const visibility = useVisibilityObserver(ref.current);
  const isInvisible = visibility === 'invisible';

  return (
    <Box position="relative">
      <Box ref={containerRef} overflowY="auto" {...BoxProps}>
        {render(ref)}
      </Box>

      <Box position="absolute" bottom={0} right={0} left={0}>
        <Fade in={isInvisible} unmountOnExit={true}>
          <BottomFade />
        </Fade>
      </Box>
    </Box>
  );
}
